<template>
        <div class="modal nb-modal-mask" style="display: block" @keyup.esc="handleCloseModal()">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document" style="overflow-y: initial !important;" @keyup.esc="handleCloseModal()">
            <div class="modal-content">
              <div class="modal-body" style="overflow-y: auto">
                <div class="row mb-5">
                  <div class="col-md-12 col-12">
                    <span style="font-size: 20px">
                      <strong>
                        Processando nota fiscal
                      </strong>
                    </span>
                    <button v-if="erro" type="button" ref="ediitemclose" class="close" @click="handleCloseModal()" data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <div v-if="message" class="row mb-4">
                  <div class="col-md-12 col-12">
                    {{ message }}
                  </div>
                </div>
                <div v-if="erro" class="row mb-5">
                  <div class="col-md-12 col-12">
                    <validation v-if="errmessages.length" :messages="errmessages"></validation>
                  </div>
                </div>
                <div v-if="erro" class="row">
                  <div class="col-md-12 col-12">
                    <v-button label="Fechar" @click="handleCloseModal"></v-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
</template>

<script>

export default {
  props: {
  },

  components: {
  },

  data() {
    return {
      erro: true,
      message: 'Gerando nota fiscal...',
      errmessages: [],
    };
  },

  computed: {
  },

  watch: {},

  filters: {},

  methods: {
    handleCloseModal() {
      this.$emit("closeModal");
    },

    enviando() {
      this.message = 'Enviando nf-e...'
    },

    rejeitada(msg, erro) {
      this.message = 'A nota fiscal foi rejeitada:'
      this.erro = true
      this.errmessages = msg
    }

  },

  created() {},

  mounted() {
    // this.erro = true
    // this.errmessages = ['tesste de rejeicao']
  }

};
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-modal-nfce.vue